import { DesignIcon } from '@monorepo/nova-icons';
import { Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TRADES_TABLE_CONSTANTS } from '../../../constants';

export const EmptyStateContainer = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  padding: TRADES_TABLE_CONSTANTS.EMPTY_STATE.PADDING,
  textAlign: 'center',
  gap: theme.spacing(2),
}));

export const EmptyStateIcon = styled(DesignIcon, {
  shouldForwardProp: () => true,
})(({ theme }) => ({
  color: 'inherit',
  width: theme.typography.pxToRem(100),
  height: theme.typography.pxToRem(100),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
  '& path': {
    fill: theme.palette.primary.main,
    stroke: theme.palette.getContrastText(theme.palette.primary.main),
  },
}));

export const EmptyStateTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontStyle: 'italic',
  fontWeight: 400,
  fontSize: theme.typography.pxToRem(
    TRADES_TABLE_CONSTANTS.EMPTY_STATE.TITLE_FONT_SIZE,
  ),
}));

export const EmptyStateSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: theme.typography.pxToRem(
    TRADES_TABLE_CONSTANTS.EMPTY_STATE.TITLE_FONT_SIZE,
  ),
  marginBottom: theme.spacing(1),
}));
